/**
 * URL patterns for pages that are English-only and should not be
 * redirected to localized versions.
 *
 * These patterns are used by:
 * - Language redirect logic (src/utils/routes.ts)
 * - Sitemap exclusion (gatsby-config.ts)
 */

// Regex patterns for checking URLs at runtime (language redirect)
export const ENGLISH_ONLY_PATTERNS: RegExp[] = [
  /^\/tutoring(\/|$)/, // /tutoring and /tutoring/*
  /^\/lp(\/|$)/, // /lp and /lp/*
  /^\/districts(\/|$)/, // /districts and /districts/*
  /^\/for(\/|$)/, // /for/<slug> -- English-only audience landing pages
];

// Glob patterns for sitemap exclusion (build time)
// Note: Only non-indexable pages should be here
export const SITEMAP_EXCLUSIONS: string[] = [
  `/lp/*`, // Landing pages - not indexable
  `/ul/*`, // Universal links - noindex pages (no localized versions generated)
  `/email/*`, // Email management pages - not indexable
  `/photo-updates`, // Photo uploads incident notice - not indexable
];

/**
 * Check if a pathname should be excluded from language redirection
 */
export const shouldSkipLanguageRedirect = (pathname: string): boolean => {
  return ENGLISH_ONLY_PATTERNS.some((pattern) => pattern.test(pathname));
};
